export default __webpack_public_path__ + "static/media/8.82cc6103.png";